import { SignDirectionPlusIcon } from './SignDirectionPlusIcon';

/**
 * author: Michael Richins
 * id 298F86D9-24E7-4780-A891-1A7C36D65D77
 * name sign-direction-plus
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sign-direction-plus.svg
 * tags
 */
export const MilestoneAddIcon = SignDirectionPlusIcon;
export default MilestoneAddIcon